import { AxiosError } from 'axios';
import { apiClient } from './api/client';

export class GatewayService {
  static async getRegistries(userUid: string): Promise<any[]> {
    try {
      const response = await apiClient.axios.post(
        `/sensor_devices/get_users_registries_docs`,
        { userUid },
        {}
      );
      return response.data?.registries || [];
    } catch (error) {
      const e = error as AxiosError;
      throw new Error(`getRegistries failed: ${e.message}`);
    }
  }

  /**
   * Unlink (force delete) a gateway: skips the gateway reset / BLE verification
   * and wipes the cloud registry, gateway and its joined devices.
   * @param gatewayId - Gateway ID with or without the 'CGReg_' registry prefix
   */
  static async forceDeleteGateway(gatewayId: string): Promise<any> {
    try {
      const id = gatewayId.startsWith('CGReg_') ? gatewayId.split('CGReg_')[1] : gatewayId;
      const response = await apiClient.axios.post(`/gateways/delete_cloud_registry_and_gateway`, { gatewayId: id });
      return response.data;
    } catch (error) {
      const e = error as AxiosError;
      throw new Error(`forceDeleteGateway failed: ${e.message}`);
    }
  }
}


